export default "__VITE_ASSET__D39RksqU__"